// 교재관리 필드명 리스트
export const BookAttributes = Object({
  bookCode : '교재 코드',
  bookName : '교재명',
  bookSeq : '',
  codeType : '교재',
  course : '',
  courseCode : '코스 코드',
  courseName : '코스명',
  gangNumber : '',
  isCanEightCha : '',
  isCanFourCha : '',
  isCanTwelvCha : '',
  isUse : '사용',
  level : '레벨',
  levelCode : '레벨 코드',
  levelName : '레벨명',
  orderInCourse : 'Order in Course',
  price : '가격',
  remark : '비고',
  totalVolume : '총 권수',
  unitCode : '유닛 코드',
  unitPerBook : '교재 유닛수',
  volumeCode : '권 코드',
  volumeNumber : '권'
})